import { createSelector } from "reselect";

const selectFormularioAssociadoProcesso = (state) => state.formularioAssociadoProcesso;

export const makeSelectFormularioModeloByProcessoId = (idProcesso) => createSelector(
  [selectFormularioAssociadoProcesso],
  (formularioAssociadoProcesso) => formularioAssociadoProcesso[idProcesso] ?? null
);
